<template>
  <client-only>
    <div>
      <main>
        <ContactsHeroSection />
        <ContactsFormSection class="pt-[130px] pb-[150px] mx-auto"/>
      </main>

      <LayoutBackToTop />
    </div>
  </client-only>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'full-width'
})
</script>

<style scoped>
main {
  margin: 0 auto;
  overflow-x: hidden;
  width: 100%;
}
</style>